var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.062 17.9993C20.062 22.7503 16.0185 26.608 11.0093 26.608C6.0001 26.608 1.95654 22.7503 1.95654 17.9993C1.95654 13.2484 6.0001 9.39062 11.0093 9.39062C16.0185 9.39062 20.062 13.2484 20.062 17.9993ZM29.9798 17.9993C29.9798 22.4652 27.948 26.0949 25.4534 26.0949C22.9589 26.0949 20.9271 22.4652 20.9271 17.9993C20.9271 13.5334 22.9589 9.90372 25.4534 9.90372C27.948 9.90372 29.9798 13.5144 29.9798 17.9993ZM34.0435 17.9993C34.0435 22.0091 33.3394 25.2588 32.4542 25.2588C31.5691 25.2588 30.865 22.0091 30.865 17.9993C30.865 13.9895 31.5691 10.7399 32.4542 10.7399C33.3394 10.7399 34.0435 13.9895 34.0435 17.9993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.9d1d4a3e9c1b06479cbe1d99c7c6b45d.svg";
export { ForwardRef as ReactComponent };